import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, combineLatest, forkJoin, Observable, Subscription} from 'rxjs';
import CooperationEventModel from '../../../model/cooperationEvent.model';
import CooperationTaskModel from '../../../model/cooperationTask.model';
import NoteModel from '../../../model/note.model';
import TaskService from '../../../api/task/task.service';
import EventService from '../../../api/event/event.service';
import NoteService from '../../../api/note/note.service';
import DoingService from '../../../api/doing/doing.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import ContextBarService from './context-bar.service';
import CooperationModel from '../../../model/cooperation.model';
import {MatDialog} from '@angular/material/dialog';
import ArtistModel from '../../../model/artist.model';
import CustomerModel from '../../../model/customer.model';
import UserModel from '../../../model/user.model';
import DoingModel from '../../../model/doing.model';
import {EventFormComponent, EventFormDialogModel} from '../event/event-form/event-form.component';
import ArtistContext from '../../util/artist.context';
import CooperationService from '../../../api/cooperation/cooperation.service';
import {Router} from '@angular/router';
import {debounceTime, distinctUntilChanged, first, skip} from 'rxjs/operators';
import UpdateService from '../../../api/update.service';
import {
  CooperationDialogComponent,
  CooperationDialogModel
} from "../../dialogs/cooperation-dialog/cooperation-dialog.component";
import {CalendarEvent} from "../mini-calendar/mini-calendar.component";
import dayjs from "dayjs";
import CalendarService from "../../../api/calendar/calendar.service";

@Component({
  selector: 'app-context-bar',
  templateUrl: './context-bar.component.html',
  styleUrls: ['./context-bar.component.scss']
})
export class ContextBarComponent {
  public artist$: Observable<ArtistModel>;
  public constructor(private contextBarService: ContextBarService) {
    this.artist$ = this.contextBarService.artist$;
  }
}
